const SDK_VERSION = '8.28.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
